import { Link, useParams } from "react-router-dom";
import Error from "../../Components/Error";
import Loading from "../../Components/Loading";
import { useGetProductQuery } from "../../Redux/Apis/shopApi";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import Product from "../Components/Product";
import RelatedItems from "../Components/RelatedItems";

export default function Single(){
    const params = useParams()
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
      } = useGetProductQuery(params.id)

      if(isLoading)
        return <Loading/>
    
      else if(isError)
        return <Error data={error}/>
    
      else if(isSuccess)
        return(
            <>
            {data && data.Shop.status === "ACTIVE" ? <div className='bootstrap-iso'>
                <Navbar />
                <Product data={data}/>
                <RelatedItems data={data.related}/>
                <Footer/>
            </div> :
            <div className='bootstrap-iso text-center '>
                <div className="alert alert-warning my-5" role="alert">
                  <p>
                  چنین محصولی موجود نیست یا غیر فعال است
                  </p>
                    <Link to="/" className='btn btn-primary'>بازگشت به سایت</Link> 
                </div>
            </div>
            }
            </>
        )
}